import React from 'react'
import { Detail1 as SkeletonLine, Title as SkeletonTitle } from '../../SearchResults/uiComponents/skeletonItem'
import styled from 'styled-components'

const Table = styled.table`
	margin: 0 16px;
	table-layout: fixed;
	width: 100%;
`

const TR = styled.tr`
	border-bottom: 1px whitesmoke solid;
`

const TD = styled.td`
	word-wrap:break-word;
	padding-right: 8px;
`

export default function SkeletonLoader() {
    const SkeletonList = () => (
        <ul>
            <li>
                <SkeletonLine style={{ width: '50%' }} />
            </li>
            <li>
                <SkeletonLine style={{ width: '70%' }} />
            </li>
            <li>
                <SkeletonLine style={{ width: '40%' }} />
            </li>
            <li>
                <SkeletonLine style={{ width: '75%' }} />
            </li>
            <li>
                <SkeletonLine style={{ width: '60%' }} />
            </li>
        </ul>
    )
    
    const SkeletonTbody = () => (
        <tbody>
            <TR>
                <TD>
                    <SkeletonLine style={{ width: '50%' }} />
                </TD>
                <TD>
                    <SkeletonLine style={{ width: '50%' }} />
                </TD>
            </TR>
            <TR>
                <TD>
                    <SkeletonLine style={{ width: '50%' }} />
                </TD>
                <TD>
                    <SkeletonLine style={{ width: '50%' }} />
                </TD>
            </TR>
            <TR>
                <TD>
                    <SkeletonLine style={{ width: '50%' }} />
                </TD>
                <TD>
                    <SkeletonLine style={{ width: '50%' }} />
                </TD>
            </TR>
            <TR>
                <TD>
                    <SkeletonLine style={{ width: '50%' }} />
                </TD>
                <TD>
                    <SkeletonLine style={{ width: '50%' }} />
                </TD>
            </TR>
            <TR>
                <TD>
                    <SkeletonLine style={{ width: '50%' }} />
                </TD>
                <TD>
                    <SkeletonLine style={{ width: '50%' }} />
                </TD>
            </TR>
        </tbody>
    )

    return (
        <>
            <SkeletonTitle />
            <SkeletonList />
            <SkeletonTitle />
            <Table>
                <SkeletonTbody />
            </Table>
        </>
    )
}